import { Injectable } from '@angular/core';

declare var GlobalPayments: any;

// Loads the GlobalPayments/PayFields SDK <script> on demand (only when a payment/refund
// component actually opens its embedded card form), instead of bundling it into every page.
@Injectable({
  providedIn: 'root'
})
export class PayFieldsSdkLoaderService {
  private loadPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (typeof GlobalPayments !== 'undefined') {
      return Promise.resolve();
    }
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'assets/Scripts/globalpayments.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => {
        this.loadPromise = null;
        reject(new Error('Failed to load GlobalPayments SDK script.'));
      };
      document.head.appendChild(script);
    });

    return this.loadPromise;
  }
}
